import React from 'react';
import Draggable from 'react-draggable';
import { Om2Dropdown } from "omni-campaign-ui";
import '../../../../styles/placementFilter.css';

// Shared components and utilities
import { 
    OmniIconComponent, 
    OmniDropdownComponent, 
    OmniTooltipNextComponent,
    Utils, 
    placementStatuOption 
} from '../../../../shared';



export class PlacementFilterComponent extends React.Component {
    nodeRef = null;
    defaultState = {
        filterOptions: {
            "placementName": "",
            "startDate": "",
            "endDate": "",
            "status": "",
            "total": "",
            "plannedCostMin": "",
            "plannedCostMax": "",
            "unitsMin": "",
            "unitsMax": "",
            "rateMin":"",
            "rateMax":""
        },
        isMenuActive:false,
        exportStatusOptions : placementStatuOption
    };
    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.nodeRef = React.createRef();
        Om2Dropdown.register();
    }
    
    componentDidMount() {
        this.handleDropdownClick();
    }

    /**
     * Description: The function adds event handlers to dropdown menus to open and close them on click and outside.
     */
    handleDropdownClick() {
        if (!this.loaded) {
            this.loaded = true;
            // Get all dropdowns on the page that aren't hoverable.
            this.dropdowns = document.querySelectorAll('.dropdown:not(.is-hoverable)');

            if (this.dropdowns.length > 0) {
                // For each dropdown, add event handler to open on click.
                this.dropdowns.forEach((el) => {
                    el.addEventListener('click', (e) => {
                        //first close all dropdown
                        this.closeDropdowns(e);
                        if (!el.classList.contains("is-active")) {
                            el.classList.toggle('is-active');
                            let container = document.querySelectorAll('.dropdown-content');
                            let exists = false;
                            container.forEach((item) => {
                                if ((!exists && item === e.target) || item.contains(e.target)) {
                                    exists = true
                                }
                            })

                            if (!exists) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }
                    });
                });

                // If user clicks outside dropdown, close it.
                document.addEventListener('click', (e) => {
                    this.closeDropdowns(e);
                });
            }
        }
    }

    /**
     * Description: This will update the dropdowns
     * @param {string} event: event is optional
     */
    closeDropdowns = (event) => {
        this.dropdowns.forEach(function (el) {
            el.classList.remove('is-active');
        });
    }

    /**
     * Description: This is defining a function called `handleModalClick`
     * @param {string} event
     * This is commonly used in modal windows to prevent clicks outside of the modal from closing it.
     */
    handleModalClick = (event) => {
        event.stopPropagation();
    }

    /**
     * Description: This will update menu
     * @param {string} event: event is optional
     */
    toggleMenu = (event) => {
        event.stopPropagation();
        event.preventDefault();
        document.getElementById("placement-filter-container").classList.toggle("show");
        const isMenuActive = document.getElementById("placement-filter-container")?.classList.contains("show") ? true : false;
        if(isMenuActive){
            document.querySelectorAll("om2-dropdown-impl").forEach(eachEle =>{
                eachEle.shadowRoot.querySelector(".dropdown-content").style.position = "initial";
            });
        }
        this.setState({isMenuActive})
    }

    /**
     * The function returns the target element of a given event object.
     * @param event - The parameter "event" is an event object that is passed as an argument to the function.
     * It represents an event that has occurred, such as a mouse click or a keyboard press. The
     * function is designed to retrieve the target element of the event, which is the element that
     * triggered the event.
     * @returns the target element of the event object passed as a parameter. If the event object does
     * not exist, it will use the window.event object instead. If the target element does not exist, it
     * will return the source element instead.
     */
    getEventTarget(event) {
        event = event || window.event;
        return event.target || event.srcElement;
    }

    /**
     * Description: This is defining an arrow function called `onValueChange` 
     * @param {string} type
     * @param {string} event
     * This is likely part of a larger program that handles user input and updates filter options based on that input.
     */
    onValueChange = (type, event) => {
        let target = this.getEventTarget(event);
        const value = target.textContent;
        this.updateFilterOptions(type, value);
    }

    /**
     * Description: This is defining a function called `onDataChange`
     * @param {string} type
     * @param {string} event
     */
    onDataChange = (type, event) => {
        let value = Utils.getValue(event)
        if (type === "startDate" || type === "endDate") {
           value = Utils.formatDateObject(value);
          }
        this.updateFilterOptions(type, value);
    }

    /**
     * Description: it will update the filter options
     * @param {string} type
     * @param {string} value
     * This function is likely used to update the filter options of a component based on user input
     */
    updateFilterOptions = (type, value) => {
        let filterOptions = { ...this.state.filterOptions };
        filterOptions[type] = value;
        this.setState({ filterOptions: filterOptions });
    }

    /**
     * Description: clearing the filter
     * @param {any} event
     * @returns {any}: This function is likely used to reset the filter options to their default values and apply the default filter to the data being displayed.
     */
    onClearfFilter = (event) => {
        this.setState({ filterOptions: this.defaultState.filterOptions });
        this.props.onApplyFilter(this.defaultState.filterOptions);
        this.toggleMenu(event);
    }

    /**
     * Description; to apply the filter
     * @param {string} event
     * The purpose of this code is to apply a filter to some data and close a menu. 
     */
    applyFilter = (event) => {
        this.props.onApplyFilter(this.state.filterOptions);
        this.toggleMenu(event);
    }


    // Method to find out passed item is null, mostly used as callback method in array methods
    isNull = (item) => !item

    render() {
        const {isMenuActive,filterOptions} = this.state;
        const disableApplyFilter=(Object.values(filterOptions).every(this.isNull));  // If every value is null, disable the apply button
       return (
            <div className="menu-wrapper">
                <div className={`menu-trigger ${isMenuActive ? "bg-blue" : ""}`} onClick={this.toggleMenu}>
                <OmniTooltipNextComponent> 
                    <button slot="invoker" aria-haspopup="true" className={`icon filter-button ${isMenuActive ? "bg-blue" : ""}`}> 
                        <OmniIconComponent slot="end" className="menu-trigger is-size-2 has-text-almost-black"icon-id="omni:interactive:filter"></OmniIconComponent> 
                    </button>
                    <div slot="content">Filters</div>
                </OmniTooltipNextComponent>
                </div>
                <Draggable nodeRef={this.nodeRef} axis="both" bounds='body'  defaultPosition={{x: 54, y: 8}}>
                    <div ref={this.nodeRef}>
                        <div className="dropdown-menu-content placement-filter-container" id="placement-filter-container" role="menu">
                            <div>
                                <div className="media-flex media-justify-space-between filter-header">
                                    <span className='filter-title'>Filters</span>
                                    <OmniIconComponent onClick={this.toggleMenu} className="is-size-2 has-text-almost-black fliter-close-icon"
                                        icon-id="omni:interactive:close"></OmniIconComponent>
                                </div>
                                <hr className='filter-header-bar'/>
                                <div className="filter-sections">
                                    <div className='filter-sections-list'>
                                <section className="section-item media-direction-column">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Placement name</span>
                                        <a className="media-link" onClick={this.onClearfFilter}>Clear All</a>
                                    </div>
                                    <div className="full-width">
                                        <input type="text" placeholder="Placement Name" value={this.state.filterOptions.placementName}
                                            onChange={this.onDataChange.bind(this, 'placementName')} className="input text filter-field">
                                        </input>
                                    </div>
                                </section>
                                
                                <section className="media-direction-column mt-4 section-item">
                                    <div className="media-flex media-justify-space-between is-7 filter-label">
                                        <span className="filter-label-text">Export Status</span>
                                    </div>
                                    <div className="full-width">
                                     <OmniDropdownComponent
                                            typeahead
                                            searchindropdown
                                            options={this.state.exportStatusOptions}
                                            value={this.state.filterOptions.status?[this.state.filterOptions.status]:[]}
                                            onDropdownChange={(event) => this.onDataChange("status", event)}
                                            placeholder="Select Option"
                                            hidefooter={true}
                                            ></OmniDropdownComponent>
                                    </div>
                                </section>
                                
                                <section className="media-direction-column mt-4 section-item side-section">
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-left-box filter-label">
                                        <span className="filter-label-text">Start date</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="date" data-date={this.state.filterOptions.startDate != "" ? this.state.filterOptions.startDate : "MM DD,YYYY" } value={this.state.filterOptions.startDate} 
                                            onChange={this.onDataChange.bind(this, 'startDate')} className="input date is-large filter-field input-with-icon">
                                        </input>
                                    </div>
                                    </label>
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-right-box filter-label">
                                        <span className="filter-label-text">End date</span>
                                    </div>
                                    <div className="full-width">
                                        <input type="date" data-date={this.state.filterOptions.endDate != "" ? this.state.filterOptions.endDate : "MM DD,YYYY" }onChange={this.onDataChange.bind(this, 'endDate')} value={this.state.filterOptions.endDate} className="input date is-large filter-field input-with-icon">
                                        </input>
                                    </div>
                                    </label>
                                </section>

                                <section className="section-item media-direction-column mt-4 side-section">
                                   <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-left-box filter-label">
                                        <span className="filter-label-text">Total Min</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.plannedCostMin}
                                        onChange={this.onDataChange.bind(this, 'plannedCostMin')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-right-box filter-label">
                                        <span className="filter-label-text">Total Max</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.plannedCostMax}
                                        onChange={this.onDataChange.bind(this, 'plannedCostMax')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                </section>
                                
                                <section className="section-item media-direction-column mt-4 side-section">
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-left-box filter-label">
                                        <span className="filter-label-text">Units Min</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.unitsMin}
                                        onChange={this.onDataChange.bind(this, 'unitsMin')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-right-box filter-label">
                                        <span className="filter-label-text">Units Max</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.unitsMax}
                                        onChange={this.onDataChange.bind(this, 'unitsMax')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                </section>

                                <section className="section-item media-direction-column mt-4 side-section">
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-left-box filter-label">
                                        <span className="filter-label-text">Rates Min</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.rateMin}
                                        onChange={this.onDataChange.bind(this, 'rateMin')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                    <label>
                                    <div className="media-flex media-justify-space-between is-7 filter-right-box filter-label">
                                        <span className="filter-label-text">Rates Max</span>
                                    </div>
                                    <div className="full-width">
                                    <input type="text" placeholder="Enter Sum" value={this.state.filterOptions.rateMax}
                                        onChange={this.onDataChange.bind(this, 'rateMax')} className="input text filter-field">
                                    </input>
                                    </div>
                                    </label>
                                </section>

                                </div>
                                <div className="action-btns mt-4">
                                    <button className={`${disableApplyFilter ? "apply-filter" : "btn-primary"}`} title="Filter" disabled={disableApplyFilter}
                                        onClick={this.applyFilter}>Apply Filters</button>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        )
    }

}